var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTextLink = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.395 9.383a3.38 3.38 0 0 0 5.306.69l2.25-2.25a3.38 3.38 0 0 0 0-4.774 3.38 3.38 0 0 0-4.773 0L8.303 4.924" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M10.605 8.618a3.38 3.38 0 0 0-5.306-.69l-2.25 2.25a3.38 3.38 0 0 0 0 4.773 3.38 3.38 0 0 0 4.773 0l1.875-1.875" })] }))); };
export default SvgTextLink;
